import {StyleType} from '../../../../utils/theming';
import {TextFieldSize, TextFieldState} from './textField_types.web';

export const inputFont = (size: TextFieldSize, fontStyles: StyleType) =>
  size === 'large' ? fontStyles['bodyRegularMD'] : fontStyles['bodyRegularSM'];
export const labelFont = (size: TextFieldSize, fontStyles: StyleType) =>
  size === 'large' ? fontStyles['bodyRegularSM'] : fontStyles['bodyRegularXS'];
export const extraDescFont = (size: TextFieldSize, fontStyles: StyleType) =>
  size === 'large' ? fontStyles['bodyRegularSM'] : fontStyles['bodyRegularCap'];

export const inputBorder = {
  enable: 'neutral400',
  disable: 'neutral300',
  hover: 'primary700',
  active: 'primary700',
  complete: 'neutral400',
  success: 'success300',
  error: 'alert300',
};

export const inputColor = (state: TextFieldState, value?: string) =>
  value?.length && state !== 'disable' ? 'neutral1000' : 'neutral600';

export const inputBackgroundColor = (state: TextFieldState) =>
  state === 'disable' ? 'neutral300' : 'neutral100';

export const helperTextColor = (state: TextFieldState) =>
  state === 'error'
    ? 'alert300'
    : state === 'success'
    ? 'success300'
    : 'neutral600';
